import './DiamondsSubscriptionSheet.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { DiamondsSubscriptionSheetProps } from './DiamondsSubscriptionSheet.interface';
import { useTranslator } from '$hooks';
import { ReactComponent as DiamondsSubscription } from '$assets/art/diamonds_subscription.svg';
import { Button } from '$uikit';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { mainActions } from '$store/main';
import { authActions } from '$store/auth';

export const DiamondsSubscriptionSheet: FC<DiamondsSubscriptionSheetProps> = (props) => {
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleActivate = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.get(`/nft/subscription`)
      .then(() => {
        dispatch(mainActions.setPopup(null));
        dispatch(authActions.init()); // Hack to get subscriptions
        dispatch(toastActions.setToastSuccess());
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [dispatch]);

  return (
    <BottomSheet>
      <div className="DiamondsSubscriptionSheet__cont">
        <div className="DiamondsSubscriptionSheet__image">
          <DiamondsSubscription />
        </div>
        <div className="DiamondsSubscriptionSheet__title">
          {t('diamonds_subscription_sheet_title')}
        </div>
        <div className="DiamondsSubscriptionSheet__caption">
          {t('diamonds_subscription_sheet_caption')}
        </div>
        <Button className="DiamondsSubscriptionSheet__button" onClick={handleActivate}>
          {t('diamonds_subscription_sheet_button')}
        </Button>
      </div>
    </BottomSheet>
  );
};
